export default "__VITE_ASSET__CGY66qRW__"